const textEncoder = new TextEncoder();

const bufferToHex = (buffer: ArrayBuffer) =>
  Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");

export async function sha256Hex(value: string | ArrayBuffer) {
  if (typeof window !== "undefined" && window.crypto?.subtle) {
    const data = typeof value === "string" ? textEncoder.encode(value) : value;
    const digest = await window.crypto.subtle.digest("SHA-256", data);
    return bufferToHex(digest);
  }

  // Fallback for Node/test environments
  const { createHash } = (await import("node:crypto")) as typeof import("node:crypto");
  const hash = createHash("sha256");
  if (typeof value === "string") {
    hash.update(value, "utf8");
  } else {
    hash.update(Buffer.from(value));
  }
  return hash.digest("hex");
}
